/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../../store'

/**
 * Import
 * - Actions
 */
import { getMTAPreview, bindMTA, removePolicySubmit } from '../../../../actions'

/**
 * Import
 * - Page component
 */
import MTAConfirm from '../../../../components/pages/Policies/MTA/components/MTAConfirm'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        mta: state.mta.summary,
        mtaBound: state.mta.bound,
    }
}

export default connect(
    mapStateToProps,
    {
        getMTAPreview,
        bindMTA,
        removePolicySubmit,
    }
)(MTAConfirm)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Policies/MTA/MTAConfirm.tsx